import { initReactI18next } from 'react-i18next';
import i18n from 'i18next';

import nlLocale from '@/localization/nlLocale.json';

const DEFAULT_LANGUAGE = 'nl';
const TRANSLATION_NAMESPACE = 'translation';
const translationBundle = {
	...nlLocale,
};

const registerTranslationBundle = (language?: string) => {
	if (!language) {
		return;
	}

	i18n.addResourceBundle(language, TRANSLATION_NAMESPACE, translationBundle, true, false);
};

if (!i18n.isInitialized) {
	i18n.use(initReactI18next) // passes i18n down to react-i18next
		.init({
			resources: {
				[DEFAULT_LANGUAGE]: {
					[TRANSLATION_NAMESPACE]: translationBundle,
				},
			},
			supportedLngs: [DEFAULT_LANGUAGE],
			lng: DEFAULT_LANGUAGE,
			fallbackLng: DEFAULT_LANGUAGE,
			interpolation: {
				escapeValue: false,
			},
			returnEmptyString: false,
		});
}

registerTranslationBundle(DEFAULT_LANGUAGE);

[i18n.language, i18n.resolvedLanguage].forEach((language) => {
	const normalizedLanguage = language?.replace('_', '-');

	if (!normalizedLanguage) {
		return;
	}

	if (normalizedLanguage.split('-')[0] === DEFAULT_LANGUAGE) {
		registerTranslationBundle(normalizedLanguage);
	}
});

export default i18n;
